export default {
  borderRadius: 'medium',
  color: 'brandOne100',
  onWhiteBackground: 'utilityBackground',
  onBackgroundBackground: 'utilityWhite',
};
